export default {
  module: {
    key: 'bbs/banner-hero',
    id: 'bbs-banner-hero',
  },
  setting: {
    welcomeBanner: 'bbs-banner-hero.welcomeBanner',
    welcomeBannerUrl: 'bbs-banner-hero.welcomeBannerUrl',
    welcomeBannerPath: 'bbs-banner-hero.welcomeBannerPath',
    welcomeBannerLink: 'bbs-banner-hero.welcomeBannerLink',
    pageBanner: 'bbs-banner-hero.pageBanner',
    pageBannerUrl: 'bbs-banner-hero.pageBannerUrl',
    pageBannerPath: 'bbs-banner-hero.pageBannerPath',
    pageBannerLink: 'bbs-banner-hero.pageBannerLink',
  },
};
